import { useMemo } from 'react'

import { getConsultationScreens, SafetyAnswers } from '../screens'
import { useConsultationData } from '../store'
import { useConsultationIntakeSpec } from './use-consultation-intake-spec'

/**
 * 진행 바용 화면 구성. 주요 증상을 정하지 않았으면 'others' 경로를 기준으로 한다.
 * 질문지를 받기 전에는 전체 화면 수를 알 수 없어 null (진행 바를 그리지 않음).
 */
export const useConsultationScreens = (mainConcern?: string) => {
  const { data: spec, isPending } = useConsultationIntakeSpec()
  const [consultationData] = useConsultationData()

  return useMemo(() => {
    if (isPending) return null
    const checkup = consultationData.checkup
    const concern =
      mainConcern ??
      Object.entries(checkup ?? {}).find(([, value]) => value !== null)?.[0] ??
      'others'
    const category = (checkup?.others as Record<string, unknown> | null)?.category as
      | string
      | undefined
    const answers = (checkup?.[concern] as Record<string, unknown> | null)?.safety as
      | SafetyAnswers
      | undefined
    return getConsultationScreens({ concern, category, spec, answers, pet: consultationData.pet })
  }, [consultationData.checkup, consultationData.pet, isPending, mainConcern, spec])
}
